

































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

const payTypeList = [
  {
    'id': 1,
    'name': 'PayPal'
  },
  {
    'id': 2,
    'name': '支付宝'
  },
  {
    'id': 3,
    'name': 'PaymentWall'
  }
]
const statusList = [
  {
    'id': 1,
    'name': '已付款'
  },
  {
    'id': 2,
    'name': '代付款'
  },
  {
    'id': 3,
    'name': '付款失败'
  }
]
const exchangeTypeList = [
  {
    'id': 1,
    'name': '美元 -> 人民币'
  },
  {
    'id': 2,
    'name': '人民币 -> 美元'
  },
  {
    'id': 3,
    'name': '人民币 -> 欧元'
  }
]

@Component({
  name: 'TradeExchange'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    user: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private formParams = {
    exchangeType: '',
    remark: '',
    rate: 0
  }
  // component data
  payTypeList = payTypeList
  statusList = statusList
  exchangeTypeList = exchangeTypeList
  dateArrayCreate = ['', '']
  dateArrayPay = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0
  formVisible = false
  tableHeight: number = 800
  rules: any = {
    exchangeType: [{ required: true, message: '请选择', trigger: 'change' }],
    rate: [{ required: true, message: '请输入汇率', trigger: 'blur' }]
  }
  // lifecycle
  async created() {
    this.getTableData()
    // this.getAccountStatus()
    // this.getAreaList()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  // methods
  getTableData() {
    this.tableLoading = true
    // let res = await getAccountList(this.params)
    for (let i = 0; i < 10; i++) {
      this.tableData.push({
        id: 1 + i,
        coinOne: '美元',
        coinTwo: '人民币',
        rate: '6.67',
        createDate: '2019-08-25 14:54',
        user: 'xxoo',
        desc: '已付款'
      })
    }
    this.tableLoading = false
    // this.tableData = res.data.dataList
    // this.totalCount = res.data.pageInfo.totalCount
  }
  handleDateChangeCreate(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  async handleExcel() {
    // let res: any = await getAccountList({
    //   page: 1,
    //   pageCount: 3000
    // })
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'accountId',
    //   'certName',
    //   'applePwd',
    //   'iphoneCount',
    //   'itouchCount',
    //   'status',
    //   'info',
    //   'createDate',
    //   'creatorName'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '开发者账号',
    //   '证书',
    //   '专用密码',
    //   'iPhone可安装数量',
    //   'iPad可安装数量',
    //   '状态',
    //   '信息',
    //   '创建时间',
    //   '创建人'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayPay = ['', '']
    this.dateArrayCreate = ['', '']
    this.params.page = 1
  }
  handleAdd() {
    this.formVisible = true
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelForm()
  }
  cancelForm() {
    (this.$refs['formParams'] as Form).resetFields()
    this.formVisible = false
  }
  confirmForm() {
    (this.$refs['formParams'] as Form).validate(valid => {
      if (valid) {
        alert(1111)
      } else {
        this['$message'].warning('请填写完成后再提交!')
        return false
      }
    })
  }
}
